import { Card, CardBody, Col } from "reactstrap";
import { SALE_REPORT_DATA } from "../../../../Data/Widgets/GeneralWidgets";
import { H4, SVG } from "../../../../AbstractElements";

const SalesReport = () => {
  return (
    <>
      {SALE_REPORT_DATA.map((data, index) => (
        <Col key={index} sm="6" xl="3" lg="6" className="box-col-3">
          <Card className="widget-1">
            <CardBody>
              <div className="widget-content">
                <div className={`widget-round ${data.color}`}>
                  <div className="bg-round">
                    <SVG className="svg-fill" iconId={`${data.icon}`} />
                    <SVG className="half-circle svg-fill" iconId="halfcircle"/>
                  </div>
                </div>
                <div>
                  <H4>{data.total}</H4>
                  <span className="f-light">{data.title}</span>
                </div>
              </div>
              <div className={`font-${data.color} f-w-500`}>
                <i className={`icon-arrow-${data.gros < 50 ? "down" : "up"} icon-rotate me-1`}/>
                <span>{`${data.gros < 50 ? "-" : "+"}${data.gros}%`}</span>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default SalesReport;
